import { render } from "./ViewCompanyView.vue?vue&type=template&id=3b671b20&scoped=true"
import script from "./ViewCompanyView.vue?vue&type=script&lang=js"
export * from "./ViewCompanyView.vue?vue&type=script&lang=js"

import "./ViewCompanyView.vue?vue&type=style&index=0&id=3b671b20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b671b20"]])

export default __exports__